import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as userActions from "../../actions/userActions";

import ResetPassForm from "./ResetPassForm";

class ResetPage extends Component {
  constructor(props) {
    super(props);

    const token = window.location.pathname.substr(
      window.location.pathname.lastIndexOf("/") + 1
    );

    this.state = {
      login: {
        token,
        newPassword: "",
        verifyPassword: ""
      }
    };
  }

  handleSave = (user) => {
    user.token = this.state.login.token;
    this.props.actions.resetPassword(user);
  };

  render() {
    return (
      <div className="login-page">
        <ResetPassForm
          onSave={this.handleSave}
          saving={this.props.savingUser}
        />
      </div>
    );
  }
}

ResetPage.propTypes = {
  actions: PropTypes.object.isRequired,
  savingUser: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state,
    savingUser: state.reducers.savingUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ResetPage);
